import Vue from "vue";
import Router from "vue-router";
import Main from "@/components/Main.vue";
import RacesPrint from '@/components/standing/RacesPrint';
import InvoiceView from '@/components/invoices/InvoiceView';
import VirtualPoker from '@/components/vpoker/Index.vue';

Vue.use(Router);

export default new Router(
    {
        mode: "history",
        base: process.env.BASE_URL,
        routes: [
            {
                path: '/',
                name: 'Main',
                component: Main,
                props: {
                    page: 'home'
                }
            },
            {
                path: '/login',
                name: 'Login',
                component: Main,
                props: {
                    page: 'login'
                }
            },
            {
                path: '/join',
                name: 'Register',
                component: Main,
                props: {
                    page: 'register'
                }
            },
            {
                path: '/restore-password',
                name: 'RestorePassword',
                component: Main,
                props: {
                    page: 'restore-password'
                }
            },
            {
                path: '/today',
                name: 'AhlToday',
                component: Main,
                props: {
                    page: 'home'
                }
            },
            {
                path: '/terms',
                name: 'Terms',
                component: Main,
                props: {
                    page: 'terms'
                }
            },
            {
                path: '/recent-winners',
                name: 'RecentWinners',
                component: Main,
                props: {
                    page: 'home'
                }
            },
            {
                path: '/hire-ahl-poker',
                name: 'SpecialEvents',
                component: Main,
                props: {
                    page: 'special-events'
                }
            },
            {
                path: '/mybonuses',
                name: 'MyBonuses',
                component: Main,
                props: {
                    page: 'mybonuses'
                }
            },
            {
                path: '/all-stars',
                name: 'AllStars',
                component: Main,
                props: {
                    page: 'home'
                }
            },
            {
                path: '/news',
                name: 'News',
                component: Main,
                props: {
                    page: 'home'
                }
            },
            {
                path: '/calendar',
                name: 'Calendar',
                component: Main,
                props: {
                    page: 'calendar',
                    state: '',
                    selectedRegion: ''
                }
            },
            {
                path: '/calendar/:region',
                name: 'CalendarToday',
                component: Main,
                props: {
                    page: 'calendar',
                    state: '',
                    selectedRegion: ''
                }
            },
            {
                path: '/calendar/:region/:style',
                name: 'CalendarTodayWithRegion',
                component: Main,
                props: {
                    page: 'calendar',
                    state: '',
                    selectedRegion: ''
                }
            },
            {
                path: '/subscribe',
                name: 'Email Subscribe',
                component: Main,
                props: {
                    page: 'EmailSubscribe'
                }
            },
            {
                path: '/allnews',
                name: 'News',
                component: Main,
                props: {
                    page: 'news'
                }
            },
            {
                path: '/allnews',
                name: 'News',
                component: Main,
                props: {
                    page: 'news'
                }
            },
            {
                path: '/allnews',
                name: 'News',
                component: Main,
                props: {
                    page: 'news'
                }
            },
            {
                path: '/news/:id/:title?',
                name: 'News-details',
                component: Main,
                props: {
                    page: 'news-details'
                }
            },
            {
                path: '/location',
                name: 'Location',
                component: Main,
                props: {
                    page: 'location'
                }
            },
            {
                path: '/location/:state',
                name: 'LocationRegion',
                component: Main,
                props: {
                    page: 'location-region'
                }
            },
            {
                path: '/rules',
                name: 'Rules',
                component: Main,
                props: {
                    page: 'rules'
                }
            },
            {
                path: '/jobs',
                name: 'Job',
                component: Main,
                props: {
                    page: 'jobs'
                }
            },
            {
                path: '/services',
                name: 'Services',
                component: Main,
                props: {
                    page: 'services'
                }
            },
            {
                path: '/services/events',
                name: 'Services-events',
                component: Main,
                props: {
                    page: 'services-events'
                }
            },
            {
                path: '/services/join',
                name: 'ServicesJoin',
                component: Main,
                props: {
                    page: 'services-join'
                }
            },
            {
                path: '/services/fee',
                name: 'ServicesFee',
                component: Main,
                props: {
                    page: 'services-fee'
                }
            },
            {
                path: '/about_us',
                name: 'AboutUs',
                component: Main,
                props: {
                    page: 'about-us'
                }
            },
            {
                path: '/contact',
                name: 'Contact',
                component: Main,
                props: {
                    page: 'contact'
                }
            },
            {
                path: '/contact/:theme',
                name: 'ContactForm',
                component: Main,
                props: {
                    page: 'contact-form'
                }
            },
            {
                path: '/forum',
                name: 'Forum-main',
                component: Main,
                props: {
                    page: 'forum'
                }
            },
            {
                path: '/standing',
                name: 'Standing',
                component: Main,
                props: {
                    page: 'standing'
                }
            },
            {
                path: '/standing/:name',
                name: 'StandingFilterName',
                component: Main,
                props: {
                    page: 'standing'
                }
            },
            {
                path: '/standing/:name/:type',
                name: 'StandingFilterType',
                component: Main,
                props: {
                    page: 'standing'
                }
            },
            {
                path: '/standing/:name/:type/:filter',
                name: 'StandingFilter',
                component: Main,
                props: {
                    page: 'standing'
                }
            },
            {
                path: '/races',
                name: 'Races',
                component: Main,
                props: {
                    page: 'races'
                }
            },
            {
                path: '/races/print',
                name: 'RacesPrint',
                component: RacesPrint
            },
            {
                path: '/races/:filter',
                name: 'RacesFilter',
                component: Main,
                props: {
                    page: 'races'
                }
            },
            {
                path: '/races/:filter/:region',
                name: 'RacesFilterRegion',
                component: Main,
                props: {
                    page: 'races'
                }
            },
            {
                path: '/my-points',
                name: 'MyPoints',
                component: Main,
                props: {
                    page: 'my-points'
                }
            },
            {
                path: '/my-messages',
                name: 'MyMessages',
                component: Main,
                props: {
                    page: 'my-messages'
                }
            },
            {
                path: '/photo-gallery',
                name: 'PhotoGallery',
                component: Main,
                props: {
                    page: 'photo-gallery'
                }
            },
            {
                path: '/photo-upload',
                name: 'PhotoUpload',
                component: Main,
                props: {
                    page: 'photo-upload'
                }
            },
            {
                path: '/games/:style/:region/:id',
                name: 'GameDetails',
                component: Main,
                props: {
                    page: 'game-details'
                }
            },
            {
                path: '/venues/:id',
                name: 'VenueDetails',
                component: Main,
                props: {
                    page: 'venue-details'
                }
            },
            {
                path: '/tournaments/:id',
                name: 'TournamentDetails',
                component: Main,
                props: {
                    page: 'tournament-details'
                }
            },
            {
                path: '/account-edit',
                name: 'AccountEdit',
                component: Main,
                props: {
                    page: 'account-edit'
                }
            },
            {
                path: '/account-edit/set-region',
                name: 'AccountEditSetRegion',
                component: Main,
                props: {
                    page: 'set-region'
                }
            },
            {
                path: '/players/:id',
                name: 'PlayerDetails',
                component: Main,
                props: {
                    page: 'player-details'
                }
            },
            {
                path: '/my-ahl',
                name: 'MyAhl',
                component: Main,
                props: {
                    page: 'my-ahl'
                }
            },
            {
                path: '/comparison/:userOne/:userTwo',
                name: 'Comparition',
                component: Main,
                props: {
                    page: 'comparition'
                }
            },
            {
                path: '/comparison/:userOne/:userTwo/:userThree',
                name: 'ComparitionThree',
                component: Main,
                props: {
                    page: 'comparition-three'
                }
            },
            {
                path: '/search-results',
                name: 'SearchResults',
                component: Main,
                props: {
                    page: 'search-results'
                }
            },
            {
                path: '/shop',
                name: 'Shop',
                component: Main,
                props: {
                    page: 'shop'
                }
            },
            {
                path: '/vpoker/test',
                name: 'VirtualPoker',
                component: VirtualPoker,
                props: {
                    page: 'virtual-poker'
                }
            },
            {
                path: '/admin/rules',
                name: 'ToolsEditRules',
                component: Main,
                props: {
                    page: 'tools-edit-rules'
                }
            },
            {
                path: '/admin/eventtags',
                name: 'ToolsEditEventTags',
                component: Main,
                props: {
                    page: 'tools-edit-eventtags'
                }
            },
            // AHL Tools
            {
                path: '/admin/calendar',
                name: 'ToolsEditCalendar',
                component: Main,
                props: {
                    page: 'tools-edit-calendar'
                }
            },
            {
                path: '/admin/ahl-news',
                name: 'Tools',
                component: Main,
                props: {
                    page: 'tools'
                }
            },
            {
                path: '/invoice/:guid',
                name: 'InvoiceView',
                component: InvoiceView,
                props: {
                    page: 'invoice-view'
                }
            },
            {
                path: '/admin/franchises/createinvoice',
                name: 'ToolsFranchiseCreateInvoice',
                component: Main,
                props: {
                    page: 'tools-franchise-createinvoice'
                }
            },
            {
                path: '/admin/lists/emailmembers',
                name: 'ToolsEmailListMembers',
                component: Main,
                props: {
                    page: 'tools-email-list'
                }
            },
            {
                path: '/admin/lists',
                name: 'ToolsListLists',
                component: Main,
                props: {
                    page: 'tools-list-lists'
                }
            },
            {
                path: '/admin/lists/add',
                name: 'ToolsListAdd',
                component: Main,
                props: {
                    page: 'tools-list-add'
                }
            },
            {
                path: '/admin/lists/edit/:id',
                name: 'ToolsListEdit',
                component: Main,
                props: {
                    page: 'tools-list-edit'
                }
            },
            {
                path: '/admin/ahl-news/create',
                name: 'ToolsNewsCreate',
                component: Main,
                props: {
                    page: 'tools-create'
                }
            },
            {
                path: '/admin/ahl-news/:id/edit',
                name: 'ToolsNewsEdit',
                component: Main,
                props: {
                    page: 'tools-edit',
                }
            },
            {
                path: '/admin/ahl-members/',
                name: 'ToolsMembers',
                component: Main,
                props: {
                    page: 'tools-members'
                }
            },
            {
                path: '/admin/ahl-members/banned',
                name: 'ToolsBannedMembers',
                component: Main,
                props: {
                    page: 'tools-banned-members'
                }
            },
            {
                path: '/admin/ahl-members/:type',
                name: 'ToolsMembersType',
                component: Main,
                props: {
                    page: 'tools-members'
                }
            },
            {
                path: '/admin/ahl-members/:type/:ahlid',
                name: 'ToolsMembersEditAhlid',
                component: Main,
                props: {
                    page: 'tools-members'
                }
            },
            {
                path: '/admin/tournaments',
                name: 'ToolsTournaments',
                component: Main,
                props: {
                    page: 'tools-tournaments'
                }
            },
            {
                path: '/admin/hosts',
                name: 'ToolsEditHosts',
                component: Main,
                props: {
                    page: 'tools-edit-hosts'
                }
            },
            {
                path: '/admin/hosts/edit/:id',
                name: 'ToolsEditHost',
                component: Main,
                props: {
                    page: 'tools-edit-host',
                    isNew: true
                }
            },
            {
                path: '/admin/hosts/add',
                name: 'ToolsAddHost',
                component: Main,
                props: {
                    page: 'tools-add-host',
                    isNew: false
                }
            },
            {
                path: '/admin/tournaments/approve',
                name: 'ToolsTournamentApprove',
                component: Main,
                props: {
                    page: 'tools-tournament-approve'
                }
            },
            {
                path: '/admin/tournaments/create',
                name: 'ToolsTournamentCreate',
                component: Main,
                props: {
                    page: 'tools-tournament-create'
                }
            },
            {
                path: '/admin/tournaments/missing',
                name: 'ToolsTournamentsMissing',
                component: Main,
                props: {
                    page: 'tools-tournaments-missing'
                }
            },
            {
                path: '/admin/tournaments/late',
                name: 'ToolsTournamentsLate',
                component: Main,
                props: {
                    page: 'tools-tournaments-late'
                }
            },
            {
                path: '/admin/venues',
                name: 'ToolsVenuesList',
                component: Main,
                props: {
                    page: 'tools-venues-list'
                }
            },
            {
                path: '/admin/venues/edit/:id',
                name: 'ToolsVenuesEdit',
                component: Main,
                props: {
                    page: 'tools-venues-edit'
                }
            },
            {
                path: '/admin/venues/add',
                name: 'ToolsVenuesCreate',
                component: Main,
                props: {
                    page: 'tools-venues-create'
                }
            },
            {
                path: '/admin/supportemails',
                name: 'ToolsSupportEmails',
                component: Main,
                props: {
                    page: 'tools-support-emails'
                }
            },
            {
                path: '*',
                name: 'FourZeroFour',
                component: Main,
                props: {
                    page: 'four-zero-four'
                }
            }
        ]
    });
